if($('.ftgatedcontent .main .column-860').length){
$( ".ftgatedcontent .main .column-860" ).wrapInner( "<div class='lockedContent'></div>");
$('.ftgatedmessage').appendTo('.ftgatedcontent .main .column-860');
}